// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"52e5a6d4","139":"1b2bf37e","154":"73c9b6e3","165":"4d6eab57","342":"7cdb1e25","368":"a6eb544c","580":"0716c144","695":"cff9e0e1","786":"d8cc204b","787":"fd60edc9","921":"953c41fe"}[chunkId] + ".chunk.js";
};